<template>
    <div class="body_login">
        <div class="account-pages"></div>
        <div class="clearfix"></div>
        <div class="d_table w_h_100">
            <div class="d_t_cell">
                <div class="wrapper-page m-0-auto">
                    <div class="">
                        <div class="panel-heading">
                            <img src="/static/images/logo_pumpmylead.png" alt="Pump My Lead" class="img-responsive m-0-auto" style="max-height: 130px;">
                        </div>
                        <div class="panel-body">
                            <slot></slot>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <p class="c_white m-t-20">2018 &copy; by <a href="http://www.guco.com.br" target="_blank" class="link_login">Guco Agência Web</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Zendesk from '@/assets/vendor/zendesk'

    export default {
        name: 'LoginLayout',
        beforeCreate () {
            Zendesk.hide()
        },
        beforeDestroy () {
            Zendesk.show()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layouts/Login.vue